import { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import NormalInput2 from "../inputs/NormalInput2";
import { Country, State, City } from "country-state-city";
import { FaCaretDown } from "react-icons/fa";
import SimpleDropdownInput from "../inputs/SimpleDropdownInput";
import Flag from "react-world-flags";
import CountrySelectInput from "../inputs/CountrySelectInput";
import CitySelectInput from "../inputs/CitySelectInput";
import StateSelectInput from "../inputs/StateSelectInput";
import { LoadScript, useLoadScript } from "@react-google-maps/api";
import { GooglePlacesInput } from "../inputs/GooglePlacesInput";
import { useTranslation } from "../../languages";
import { FaCopy } from "react-icons/fa6";
import CountryPackage from "country-list-with-dial-code-and-flag";
import { toast } from "react-toastify";

const allCountries = CountryPackage.getAll();

const getCitiesOfCountry = (countryIsoCode, returnProp) => {
  let cities = City.getCitiesOfCountry(countryIsoCode);
  if (returnProp) return cities?.map((c) => c[returnProp]);
  else return cities;
};
const getStatesOfCountry = (countryIsoCode, returnProp) => {
  let states = State.getStatesOfCountry(countryIsoCode);
  if (returnProp) return states?.map((s) => s?.[returnProp] ?? s);
  else return states;
};
const getCitiesOfState = (countryIsoCode, stateIsoCode, returnProp) => {
  let cities = City.getCitiesOfState(countryIsoCode, stateIsoCode);
  if (returnProp) return cities?.map((c) => c?.[returnProp] ?? c);
  else return cities;
};
const AddressModal = ({
  value,
  setValue,
  label,
  title,
  copy,
  copyLocationDetailsToBilling,
  placeData,
}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [countrySelected, setCountrySelected] = useState({});
  const [countrySelectedName, setCountrySelectedName] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [stateSelected, setStateSelected] = useState(null);
  const [citySelected, setCitySelected] = useState(null);
  const [zipCodeValue, setZipCodeValue] = useState("");
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [streetAdress, setStreetAddress] = useState(null);

  useEffect(() => {
    if (countrySelected) {
      let states = getStatesOfCountry(countrySelected);
      setStateOptions(states);
      if (!stateSelected) {
        let cities = getCitiesOfCountry(countrySelected, "name");
        setCityOptions(cities);
      } else {
        console.log("getting cities of ", stateSelected);
        let cities = getCitiesOfState(
          countrySelected,
          stateSelected?.isoCode,
          "name"
        );
        setCityOptions(cities);
      }
    }
  }, [countrySelected, stateSelected]);

const validate=(enteries=[])=>{
  let validOnes=[...enteries]?.filter((item)=>{
    if((!item&&item!=="")||Object.entries(item)?.length>1){
    return true
    }
  })
  return validOnes?.length===enteries?.length;
}

  const onPressDoneBtn = () => {
    console.log("State-selected",{
      zipCodeValue,
      streetAdress,
      citySelected:citySelected?.name,
      stateSelected:stateSelected?.name,
      countrySelectedName:countrySelected,
      coordinates: {
        lat: stateSelected?.latitude,
        lng: stateSelected?.longitude,
      },
    });
    let validEnteries=validate([streetAdress,zipCodeValue,citySelected,stateSelected,countrySelected])
    if(!validEnteries){
      toast.error("Plese provide all the required fields")
      return;
    }
    setValue({
      zipCodeValue,
      streetAdress,
      citySelected:citySelected,
      stateSelected:stateSelected,
      countrySelectedName:countrySelected,
      coordinates: {
        lat: stateSelected?.latitude,
        lng: stateSelected?.longitude,
      },
    });
    setModalOpen(false);
  };

console.log("Value",value);
  
  useEffect(() => {
    if (value) {
      
      let country = allCountries?.find(
        (i) => i?.name?.toUpperCase() === (value?.countrySelectedName??value?.country??"")?.toUpperCase()
      ) ?? { name: "Select" };
      setCountrySelected(country);
      let states = getStatesOfCountry(country?.code);
      let state = states?.find((s) => s?.name === (value?.stateProvince??value?.stateSelected)) ?? {
        name: "Select",
      };
      setStateSelected(state);

      let cities = getCitiesOfState(country?.code, state?.isoCode);

      let city = cities?.find((s) => s?.name === (value?.city??value?.citySelected)) ?? {
        name: "Select",
      };

      setCitySelected(city);
      setZipCodeValue(value?.zipCode)
    }
  }, [value]);

  console.log(`address-value-${label}`, value);

  return (
    <div className="normal-input-2">
      <div className="d-flex align-items-center justify-content-between ">
        <Label className="figma-input-label">{label}</Label>
        {copy && Object.keys(placeData?.location).length > 0 && (
          <div
            className="d-flex align-items-center gap-2 text-primary "
            style={{ cursor: "pointer" }}
            onClick={copyLocationDetailsToBilling}
          >
            <FaCopy />
            <span>Copy from location</span>
          </div>
        )}
      </div>
      <Button
        className="d-flex px-3 text-black align-items-center justify-content-between full-width"
        onClick={() => setModalOpen(true)}
      >
        <div className="d-flex flex-wrap align-items-strech gap-2">
          {value?.countrySelectedName ? (
            <div
              style={{ background: "#21005d" }}
              className=" text-white rounded-pill px-3 py-2"
            >
              {value?.countrySelectedName}
            </div>
          ) : countrySelectedName ? (
            countrySelectedName
          ) : value?.country ? (
            value?.country
          ) : (
            "Select Locations"
          )}
        </div>
        <div className="color-primary-blue">
          <FaCaretDown size={20} />
        </div>
      </Button>
      <Modal
        centered
        size="lg"
        isOpen={modalOpen}
        toggle={() => setModalOpen((prev) => !prev)}
      >
        <ModalBody className="bg-white" style={{ borderRadius: "14.76px" }}>
          <h3 className="color-primary-black-7 mt-3 mb-4 f-5 text-center figma-shadowed-black-text">
            {title || t("addLocation")}
          </h3>
          <Row className="g-4">
            <Col md={6}>
              {/* <NormalInput2
                type={"address"}
                setValue={(v) => {
                  setStreetAddress(v);
                }}
                value={streetAdress}
                label={"Street Address"}
                placeholder={"Write street address"}
              /> */}
              <Col md={6}>
                <GooglePlacesInput
                  setValue={(v) => {
                    console.log("street address", v);
                    setStreetAddress(v);
                  }}
                  value={streetAdress}
                  label={t("streetAddress")}
                  placeholder={t("writeStreetAddress")}
                />
              </Col>
            </Col>
            <Col md={6}>
              <CountrySelectInput
                label={t("country")}
                adaptStyle={{ iconSize: 20 }}
                placeholder={t("selectCountry")}
                showCaret={true}
                countryFullName={true}
                value={countrySelected}
                setValueFullNameSelect={setCountrySelectedName}
                setValue={setCountrySelected}
              />
            </Col>
            <Col md={6}>
              <StateSelectInput
                label={t("state")}
                options={stateOptions}
                placeholder={t("selectState")}
                value={stateSelected}
                setValue={setStateSelected}
              />
            </Col>
            <Col md={6}>
              <CitySelectInput
                label={t("city")}
                options={cityOptions}
                value={citySelected}
                placeholder={t("selectCity")}
                setValue={setCitySelected}
              />
            </Col>
            <Col md={6}>
              <NormalInput2
                type={"number"}
                setValue={(v) => {
                  setZipCodeValue(v);
                }}
                label={t("zipCode")}
                value={zipCodeValue}
                placeholder={t("writeZipCode")}
              />
            </Col>
          </Row>
          <Row className="justify-content-center mt-5 g-0 mb-3">
            <Col md={6}>
              <Button
                // onClick={() => setModalOpen(false)}
                onClick={onPressDoneBtn}
                className="standard-rounded-btn full-width"
              >
                {t("done")}
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  );
};
export default AddressModal;
